<sharry-header></sharry-header>
<div class="trip">
  <h1 [innerHTML]="'trip.title' | i18next"></h1>
  @if (claimContents$ | async; as claimContents) {
    <section class="trip__carousel">
      @if (claimContents.length) {
        <h3>{{ 'trip.trips-offers' | i18next }}</h3>
        <div>
          @for (card of claimContents; track card.id) {
            <sharry-big-card [content]="card"></sharry-big-card>
          }
        </div>
      }
    </section>
  }

  <section class="trip__golden-carousel">
    <sharry-golden-carousel [goldenBoxes]="goldenBoxes"></sharry-golden-carousel>
  </section>

  <section class="trip__highlight">
    @for (trip of tripSelectionList(); track trip.name) {
      <sharry-card-carousel
        class="lines-heights"
        [contents]="trip.cards"
        [usePagination]="true"
        [carouselTitle]="trip.name"
        [carouselTitleClass]="'carousel-title'"
        [grid]="{ xs: 2, sm: 2, md: 3, lg: 4, xl: 4 }"
        [mode]="'compact'"></sharry-card-carousel>
    }
  </section>

  <sharry-gift-card-banner></sharry-gift-card-banner>
  @if (showBannerTripBusiness) {
    <section class="trip__business">
      <img
        src="https://media.sharry.land/app/images/trip/company-team-2x.png"
        alt="company-team-image" />
      <div class="trip__business__container">
        <h3>{{ 'trip.business.title' | i18next }}</h3>
        <p>{{ 'trip.business.description' | i18next }}</p>
        <a
          mat-stroked-button
          color="secondary"
          class="sharry-big rounded"
          [routerLink]="'business-trips' | routeTranslate"
          >{{ 'trip.business.button' | i18next }}</a
        >
      </div>
    </section>
  }
  <sharry-contact-us-button></sharry-contact-us-button>
</div>
<ng-template
  #circleTemplate
  let-card>
  <a
    class="trip__all-travels__circle"
    [ngStyle]="{
      'background-image': 'url(' + card.img + ')',
    }"
    [routerLink]="['discover' | routeTranslate, card.search]">
    <p class="bold">{{ card.title | i18next }}</p>
  </a>
</ng-template>

<sharry-footer class="is-not-mobile"></sharry-footer>
